import { JSX } from "react";
import { useFormStatus } from "react-dom";

const styles = {
    input: 'w-full rounded-lg border border-stroke py-[15px] pl-6 pr-11 font-medium text-dark outline-none focus:border-primary focus-visible:shadow-none',
    label: 'mb-2.5 block font-medium text-dark',
    button: 'flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg bg-green-700 text-white p-4 font-medium transition',
    forgotLink: 'select-none font-satoshi text-base font-medium text-dark underline duration-300 hover:text-primary',
    formGroup: 'mb-4',
    forgotButton: 'mb-4.5',
    centerText: 'mb-6 flex items-center justify-center gap-2 py-2',
};

const SigninWithPassword = (): JSX.Element => {
    async function handleSignIn(formData: FormData) {
        // Aquí puedes manejar el envío, por ejemplo:
        const email = formData.get("email");
        const password = formData.get("password");
        // Lógica de autenticación...
        console.log({ email, password });
    }

function SubmitButton() {
    const { pending, action, method, data } = useFormStatus();

    return (
        <div>
            <button type="submit" disabled={pending} className={styles.button}>
                {pending ? "Enviando..." : "Entrar"}
            </button>
            <div className="mt-2 text-xs text-gray-500">
                {pending && (
                    <div>
                        Enviando datos a: <b>{typeof action === "string" ? action : "acción local"}</b> con método <b>{typeof method === "string" ? method : "POST"}</b>
                    </div>
                )}
                {data && pending && (
                    <div>
                        Email: <b>{data.get("email") as string}</b>
                    </div>
                )}
            </div>
        </div>
    );
}

    return (
        <form action={handleSignIn}>
            <div className={styles.formGroup}>
                <label htmlFor="email" className={styles.label}>
                    Email
                </label>
                <div className="relative">
                    <input
                        name="email"
                        placeholder="Email"
                        type="email"
                        className={styles.input}
                        required
                    />
                </div>
            </div>
            <div className={styles.formGroup}>
                <label htmlFor="password" className={styles.label}>
                    Contraseña
                </label>
                <div className="relative">
                    <input
                        type="password"
                        placeholder="Contraseña"
                        name="password"
                        autoComplete="password"
                        className={styles.input}
                        required
                        minLength={8}
                    />
                </div>
            </div>

            <div className={styles.centerText}>
                <div className={styles.forgotLink}>
                    ¿Olvidaste la contraseña?
                </div>
            </div>
         

            <SubmitButton />
        </form>
    );
}
export default SigninWithPassword;